import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import APIs from './components/APIs';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Gallery from './components/Gallery';
import Documentation from './components/Documentation';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton';

function App() {
  return (
    <Router>
      <div className="App overflow-x-hidden">
        <Header />
        <main className="pt-0">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <About />
                <APIs />
                <Testimonials />
                <Blog />
{/*                 <Gallery /> */}
                <Contact />
              </>
            } />
            <Route path="/nosotros" element={
              <div className="min-h-screen bg-white">
                <About />
                <Testimonials />
                <Contact />
              </div>
            } />
            <Route path="/aps" element={
              <div className="min-h-screen bg-white">
                <APIs />
                <Contact />
              </div>
            } />
            <Route path="/blog" element={
              <div className="min-h-screen bg-white">
                <Blog />
                <Contact />
              </div>
            } />
            <Route path="/galeria" element={
              <div className="min-h-screen bg-white">
                <Gallery />
                <Contact />
              </div>
            } />
            <Route path="/documentacion" element={
              <div className="min-h-screen bg-white">
                <Documentation />
                <Contact />
              </div>
            } />
            <Route path="/contacto" element={
              <div className="min-h-screen bg-white">
                <Contact />
              </div>
            } />
          </Routes>
        </main>
        <Footer />
         <WhatsAppFloatingButton />
      </div>
    </Router>
  );
}

export default App;